
<template>
  <div class="footer-value-props-container container" :class="[schema.settings.backgroundColor, schema.settings.borderColor]">
    <header class="text-center" v-if="schema.settings.sectionHeading">
      <h4 class="footer-value-prop-heading h4 color-black">{{ schema.settings.sectionHeading }}</h4>
    </header>
    <div class="footer-value-prop-slider">
      <div class="footer-value-prop" v-for="block in schema.blocks" :key="block.id" :class="schema.settings.dividerColor">
        <div class="footer-value-prop__content">
          <div class="footer-value-prop__icon-wrapper" v-if="block.settings.icon"><img class="footer-value-prop__icon" :src="block.settings.icon" :alt="block.iconAlt || block.settings.title"/></div>
          <div class="footer-value-prop__text" :class="schema.settings.textColor">
            <div class="footer-value-prop__title" v-if="block.settings.title">{{ block.settings.title }}</div>
            <div class="footer-value-prop__body body-sm client-generated" v-if="block.settings.body" v-html="block.settings.body"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <v-link class="footer-value-props-link" v-if="schema.settings.linkUrl && schema.settings.linkText" primary="primary" :href="schema.settings.linkUrl">{{ schema.settings.linkText }}</v-link>
    </div>
  </div>
</template>

<script>
import VLink from '../buttons/VLink.vue'

export default {
  name: 'FooterValueProps',
  components: {
    VLink
  },
  props: {
    schema: Object
  },
  methods: {}
}
</script>

<style scoped lang="scss">
  .footer-value-props-container {
    border-top: 1px solid;
    padding-top: 48px;
    padding-bottom: 90px;

    @include tablet-up {
      padding-top: 90px;
      padding-bottom: 138px;
    }
  }

  .footer-value-prop-slider {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    align-items: center;

    @include tablet-up {
      flex-direction: row;
    }
  }

  .footer-value-prop-heading {
    margin-bottom: 8px;

    @include tablet-up {
      margin-bottom: 48px;
    }
  }

  .footer-value-props-link {
    margin-top: 20px;

    @include tablet-up {
      margin-top: 40px;
    }
  }

  .footer-value-prop {
    @include tablet-up {
      width: 100% !important;
      height: auto;
      margin-right: 2.75vw !important;
      padding-right: 1.325vw;
      border-right: 2px solid;
      flex-shrink: 1;
    }

    &:last-child {
      margin-right: 0 !important;
      border-right: 0;
      padding: 0;
    }

    &__pagination {
      font-size: rem(8);
      line-height: 1;
      text-align: center;
      margin-top: 24px;

      @include desktop-up {
        display: none;
      }
    }

    &__content {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
    }

    &__icon-wrapper {
      margin-bottom: 20px;
    }

    &__icon {
      display: block;
      width: 60px;
    }

    &__text {
      margin-bottom: 36px;
      text-align: center;
      @include tablet-up {
        margin-bottom: 0;
      }
    }

    &__title {
      @include h7;
      margin-bottom: 8px;
    }

    &__body {
      max-width: 230px;

      @include tablet-up {
        max-width: 300px;
      }
    }

    /deep/ &__body {
      blockquote, dd, div, dl, dt, figcaption, figure, hr, li, main, ol, p, pre, ul, strong, a {
        color: inherit;
      }
    }
  }
</style>
